export const useTokenGlobalPositionsToParagraphTokens = (
  documentId: string,
  tokenGlobalPosition: number
) => {
  const tokenStore = useParagraphTokenStore(documentId, tokenGlobalPosition);
  const paragraphId = tokenStore.paragraphId;

  if (paragraphId == undefined) return [tokenGlobalPosition];

  const paragraphStore = useDocumentParagraphStore(documentId, paragraphId);
  const paragraph = paragraphStore.paragraph;

  if (paragraph == undefined) return [tokenGlobalPosition];

  return paragraph.tokens.map((t) => t.globalPosition);
};
